'use strict';

exports.__esModule = true;

var _Route = require('react-router/Route');

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Route2.default; // Written in this round about way for babel-transform-imports


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/Route.js
 ** module id = 385
 ** module chunks = 0
 **/